import { render, staticRenderFns } from "./InputComponent.vue?vue&type=template&id=f0a58ad6&scoped=true"
import script from "./InputComponent.vue?vue&type=script&lang=js"
export * from "./InputComponent.vue?vue&type=script&lang=js"
import style0 from "./InputComponent.vue?vue&type=style&index=0&id=f0a58ad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a58ad6",
  null
  
)

export default component.exports